
import { getUserMeasureSystem } from "./user/info";

const oneKmInMiles = 0.621371
const oneKgInPounds = 2.20462

export const convertCO2GramsToBestUnit = (co2Grams, translator, user) => {
  let formattedValue = 0;
  let unit = "g";

  let unitSystem = getUserMeasureSystem(user)

  // > 1 Tonne
  if(co2Grams >= 10**6) {
    if(unitSystem === 'imperial') {
      formattedValue = Math.round(co2Grams / (10**6));
      if(translator) {
        unit = translator(" metric tons");
      } else {
        unit = " metric tons";
      }
    }
    else {
      formattedValue = Math.round(co2Grams / (10**6));
      if(translator) {
        unit = translator(" ton");
      } else {
        unit = "ton";
      }
    }
  // > 1 kg
  } else if(co2Grams >= 10**3) {
    if(unitSystem === 'imperial') {
      formattedValue = Math.round(oneKgInPounds * co2Grams / (10**3));
      unit = "lb";
    }
    else {
      formattedValue = Math.round(co2Grams / (10**3));
      unit = "kg";
    }
  } else {
    if(unitSystem === 'imperial') {
      let valueInOnce = 0.035 * co2Grams
      if(valueInOnce >= 10 ) {
        formattedValue = Math.round(valueInOnce);
      } else {
        formattedValue = Math.round(valueInOnce * 10) / 10;
      }
      unit = "oz";
    }
    else {
      formattedValue = Math.round(co2Grams);
      unit = "g";
    }
  }

  return [
    formattedValue,
    unit
  ]
}


export const convertCo2GramsByKmToBestUnit = (co2GramsByKm, user) => {
  let formattedValue = co2GramsByKm;
  let unit = "gCO2/km"; //or "ozCO2/mi" or "lbCO2/mi"

  let unitSystem = getUserMeasureSystem(user)

  if(unitSystem !== 'imperial') {
    return [
      formattedValue,
      unit
    ]
  } else {
    let co2gByMile = co2GramsByKm / oneKmInMiles;
    let co2OzByMile = 0.035 * co2gByMile;

    if(co2OzByMile >= 10 ) {
      co2OzByMile = Math.round(co2OzByMile);
    } else {
      co2OzByMile = Math.round(co2OzByMile * 10) / 10;
    }

    formattedValue = co2OzByMile;
    unit = "ozCO2/mi"
    if(co2OzByMile > 10**3) {      
      formattedValue = Math.round(oneKgInPounds * co2gByMile / 1000);
      unit = "lbCO2/mi"
    }
 
    return [
      formattedValue,
      unit
    ]
  }
}

export const convertKilometersToBestUnit = (km, translator, user) => {
  let formattedValue = 0;
  let initialValueInUnit = km;
  let unit = "km";
  let unitText = "km";

  let unitSystem = getUserMeasureSystem(user)

  if(unitSystem === 'imperial') {
    unit = 'miles'
    initialValueInUnit = km * oneKmInMiles
  }

  // > 1 billion 
  if(initialValueInUnit >= 10**9) {
    formattedValue = Math.round(100* initialValueInUnit / (10**9))/100;
    unitText = " " + translator("billions") + " " + unit
  // > 1 Million
  } else if(initialValueInUnit >= 10**6) {
    formattedValue = Math.round(100 * initialValueInUnit / (10**6))/100;
    unitText = " " + translator("millions") + " " + unit
  } else {
    formattedValue = Math.round(100 * initialValueInUnit)/100;
    unitText = " " + unit
  }

  return [
    formattedValue,
    unitText
  ]
}

export const convertKilometersInUserUnit = (km, user) => {
  let valueInUnit = km;
  let unit = 'km'
  let unitSystem = getUserMeasureSystem(user)
  
  if(unitSystem === 'imperial') {
    valueInUnit = Math.round(oneKmInMiles * km);;
    unit = 'mi'
  }
  return [
    valueInUnit,
    unit
  ]
}

export const convertKilogramsInUserUnit = (kg, user) => {
  let valueInUnit = kg;
  let unit = 'kg'
  let unitSystem = getUserMeasureSystem(user)
  
  if(unitSystem === 'imperial') {
    valueInUnit = Math.round(oneKgInPounds * kg);;
    unit = 'lb'
  }
  return [
    valueInUnit,
    unit
  ]
}

export const convertEnergyInWhToBestUnit = (energyInWh) => {
  let formattedValue = 0;
  let unit = "Wh";

  // > 1 Tonne
  if(energyInWh >= 10**9) {
    formattedValue = Math.round(energyInWh / (10**9));
    unit = "GWh";
  // > 1 kg
  } else if(energyInWh >= 10**6) {
    formattedValue = Math.round(energyInWh / (10**6));
    unit = "MWh";
  } else if(energyInWh >= 10**3) {
    formattedValue = Math.round(energyInWh / (10**3));
    unit = "kWh";
  } else {
    formattedValue = Math.round(energyInWh);
    unit = "Wh";
  }
  
  return [
    formattedValue,
    unit
  ]
}


// WEBPACK FOOTER //
// ./src/utils/unitHelper.js